import { createContext, useContext } from "react";

// Provides a function to open the "Free Audit" modal from anywhere.
export const AuditContext = createContext(() => {});
export const useAudit = () => useContext(AuditContext);
